import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LucideIconInput } from '@lucide/angular';
import { isActive } from '@tiptap/core';

export type ButtonTypes =
  | 'primary'
  | 'secondary'
  | 'ghost'
  | 'alert'
  | 'neutral'
  | 'dark'
  | 'secondary-neutral'
  | 'soft-neutral'
  | 'tertiary-neutral'
  | 'tertiary-color'
  | 'link-neutral'
  | 'link-color'
  | 'primary-alert'
  | 'secondary-alert'
  | 'tertiary-alert'
  | 'link-alert'
  | 'tag'
  | 'primary-pink'
  | 'primary-green'
  | 'smoke';

export type ButtonSizes = 'xs' | 's' | 'sm' | 'm' | 'l' | 'xl';

@Component({
  selector: 'ptl-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent implements OnInit {
  @Input() type: ButtonTypes = 'primary';
  @Input() size: ButtonSizes = 'm';
  @Input() disabled = false;
  @Input() highlighted = false;
  @Input() fullWidth = false;

  @Input() text: string;
  @Input() icon?: LucideIconInput;
  @Input() iconSuffix?: LucideIconInput;
  @Input() ariaLabel?: string;

  @Output() clicked = new EventEmitter<void>();

  isIconOnly = false;

  ngOnInit(): void {
    this.isIconOnly = !this.text && (!!this.icon || !!this.iconSuffix);
  }

  onClick(): void {
    if (!this.disabled) {
      this.clicked.emit();
    }
  }

  protected readonly isActive = isActive;
}
